import { render, staticRenderFns } from "./question-complete.vue?vue&type=template&id=716542c4&scoped=true&"
import script from "./question-complete.vue?vue&type=script&lang=js&"
export * from "./question-complete.vue?vue&type=script&lang=js&"
import style0 from "./question-complete.vue?vue&type=style&index=0&id=716542c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716542c4",
  null
  
)

export default component.exports